/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FolderMinusIcon16Light } from './FolderMinusIcon16Light';
import { FolderMinusIcon16Regular } from './FolderMinusIcon16Regular';
import { FolderMinusIcon16Solid } from './FolderMinusIcon16Solid';
import { FolderMinusIcon20Light } from './FolderMinusIcon20Light';
import { FolderMinusIcon20Regular } from './FolderMinusIcon20Regular';
import { FolderMinusIcon20Solid } from './FolderMinusIcon20Solid';
import { FolderMinusIcon24Regular } from './FolderMinusIcon24Regular';
import { FolderMinusIcon24Solid } from './FolderMinusIcon24Solid';
import { FolderMinusIcon32Regular } from './FolderMinusIcon32Regular';
import { FolderMinusIcon64Regular } from './FolderMinusIcon64Regular';
var sizes = {
    16: {
        light: FolderMinusIcon16Light,
        regular: FolderMinusIcon16Regular,
        solid: FolderMinusIcon16Solid,
    },
    20: {
        light: FolderMinusIcon20Light,
        regular: FolderMinusIcon20Regular,
        solid: FolderMinusIcon20Solid,
    },
    24: {
        regular: FolderMinusIcon24Regular,
        solid: FolderMinusIcon24Solid,
    },
    32: {
        regular: FolderMinusIcon32Regular,
    },
    64: {
        regular: FolderMinusIcon64Regular,
    },
};
export var FolderMinusIcon = forwardRef('FolderMinusIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
